module.exports = __webpack_public_path__ + "static/saisons_2-a8c613b7bc734e0b266d54d5e2d66a5a.png";